import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { BottomBar } from "../../components/bar/Bottom.Bar";
import Container from "../../components/layouts/Container";
import RenderLoading from "../../components/loading/RenderLoading";
import { ContextLanguage } from "../../context/Context.Language";
import api from "../../utils/useApi";
import {
  TEXT_CREATE_ORDER,
  TEXT_LOG_IN,
  TEXT_MY_ORDERS,
} from "../../utils/useConstants";
import { STATE_CONSTANTS_ORDER } from "../../utils/useConstantState";
import { StoreLoadingOrder, SystemStoreOrders } from "../../utils/useStorage";
import {
  STYLE_HEIGHT_BAR,
  STYLE_MIN_H_FULL,
  STYLE_SCREEN_FULL,
} from "../../utils/useStyle";
import ProfileLogin from "../profile/render/Profile.Login";
import OrderBeforeLogin from "./render/Order.BeforeLogin";
import OrderMyOrder from "./render/Order.MyOrder";
import OrderSuccess from "./render/Order.Success";

const OrderMain = ({ login }) => {
  const [tab, setTab] = React.useState(STATE_CONSTANTS_ORDER.CURRENT);
  // const [orders, setOrders] = React.useState([]);
  const orders = SystemStoreOrders((state) => state.orders);
  const setOrders = SystemStoreOrders((state) => state.setOrders);

  const { user, loading: userLoading } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = React.useContext(ContextLanguage);
  // const [loading, setLoading] = React.useState(true);

  const setLoadingOrder = StoreLoadingOrder((state) => state.setLoadingOrder);
  const loadingOrder = StoreLoadingOrder((state) => state.loadingOrder);

  React.useEffect(() => {
    const thisState = sessionStorage.getItem("order");
    if (thisState) {
      setTab(thisState);
      sessionStorage.removeItem("order");
    }
    if (user) {
      FunctionLoadMyOrder();
    }
    // LoadOrders();
  }, [user]);

  const FunctionLoadMyOrder = async () => {
    try {
      setLoadingOrder(true);
      const { data } = await api.post("/orders/get", {
        phone_number: user?.phone_number,
      });
      setOrders(data?.orders);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingOrder(false);
    }
  };

  // React.useEffect(() => {
  //   window.addEventListener("pageshow", () => {
  //     FunctionLoadMyOrder();
  //   });
  //   return () => {
  //     window.removeEventListener("beforeunload", () => {
  //       FunctionLoadMyOrder();
  //     });
  //   };
  // }, []);
  // console.log("orders", orders);

  // const LoadOrders = async () => {
  //   if (userLoading) return;
  //   setLoading(true);
  //   try {
  //     if (user) {
  //       const { data } = await api.post("/orders/get", {
  //         phone_number: user?.phone_number,
  //       });

  //       setOrders(data?.orders);
  //       setLoading(false);
  //     } else {
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("ERROR TO LOAD ORDER ", error);
  //   }
  // };

  if (loadingOrder) {
    return <div className="h-screen bg-white" />;
  }
  if (userLoading || orders === "loading") {
    return <div className="w-screen h-screen bg-white"></div>;
  }

  if (orders?.length > 0) {
    return <OrderMyOrder orders={orders} />;
  }

  if (tab === STATE_CONSTANTS_ORDER.CURRENT) {
    return (
      <div className={STYLE_SCREEN_FULL}>
        <Container>
          <OrderBeforeLogin
            setTab={setTab}
            STATE_CONSTANTS={STATE_CONSTANTS_ORDER}
          />
        </Container>
        <BottomBar
          classNameBottomBar={`${STYLE_HEIGHT_BAR}`}
          title={user ? TEXT_CREATE_ORDER[language] : TEXT_LOG_IN[language]}
          onClick={() => {
            if (user) {
              navigate("/OurServices");
            } else {
              sessionStorage.setItem("redirect", location.pathname);
              navigate("/Login");
            }
          }}
        />
      </div>
    );
  } else if (tab === STATE_CONSTANTS_ORDER.SUCCESS) {
    return <OrderSuccess setTab={setTab} />;
  } else {
    return (
      <Container>
        <ProfileLogin
          setTab={setTab}
          STATE_CONSTANTS={STATE_CONSTANTS_ORDER}
          title={TEXT_MY_ORDERS}
          to={STATE_CONSTANTS_ORDER.ORDER}
        />
      </Container>
    );
  }
};

export default OrderMain;
